import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLangContext } from "context/Lang";
import { AsyncProcess } from "services/AsyncProcess";
import { routes } from "routes";
import { Loader } from "components/Loader/Loader";
import { motion } from "framer-motion";
import { Map, ExternalLink, ShieldCheck } from "lucide-react";
import { Button } from "components/Button/Button";

export const ActiveMaps = () => {
    const { gW } = useLangContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [activeMaps, setActiveMaps] = useState<MapType[]>([]);

    const fetchActiveMaps = () => {
        setLoading(true);
        AsyncProcess({
            type: "get",
            url: `${routes.api.maps}/active`,
            setError: () => setLoading(false),
            effectProcess: [(res) => {
                if (res?.success !== false) {

                    // consoe.log()
                    // الـ API يرجع الخرائط النشطة مباشرة الآن
                    setActiveMaps(res?.data || []);
                }
                setLoading(false);
            }]
        });
    };

    useEffect(() => {
        fetchActiveMaps();
    }, []);

    if (loading) return <div className="flex justify-center p-20"><Loader /></div>;

    return (
        <motion.div 
            initial={{ opacity: 0, y: 10 }} 
            animate={{ opacity: 1, y: 0 }}
            className="p-6"
        >
            <div className="flex items-center justify-between mb-8">
                <div>
                    {/* تحديث الترجمة إلى الـ Key الجديد active-maps */}
                    <h1 className="text-2xl font-bold text-primary-800">{gW("active-maps")}</h1>
                    <p className="text-primary-500">{gW("view-and-manage-active-campus-maps")}</p>
                </div>
                <div className="bg-primary-100 p-2 rounded-lg">
                    <ShieldCheck className="text-primary-600" size={24} />
                </div>
            </div>

            {activeMaps.length === 0 ? (
                <div className="text-center py-20 bg-primary-50 rounded-2xl border-2 border-dashed border-primary-200">
                    <Map className="mx-auto text-primary-300 mb-4" size={48} />
                    <p className="text-primary-500 italic">{gW("no-active-maps-found")}</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {activeMaps.map((map) => (
                        <div 
                            key={map.id} 
                            className="bg-white rounded-2xl border border-primary-100 p-5 shadow-sm hover:shadow-md transition-shadow"
                        >
                            <div className="flex items-start justify-between mb-4">
                                <div className="bg-primary-50 p-3 rounded-xl">
                                    <Map className="text-primary-600" size={24} />
                                </div>
                                
                            </div>

                            <h3 className="text-lg font-bold text-primary-800 mb-1">
                                {map?.title}
                            </h3>
                            <p className="text-sm text-primary-500 flex items-center gap-1 mb-6 line-clamp-2 h-10">
                                {map?.description || gW("no-description")}
                            </p>

                           {map?.editors?.[0]?.id ? (
                                <Button 
                                    className="w-full justify-center gap-2 bg-primary-600 hover:bg-primary-700 text-white"
                                    onClick={() => navigate(`${routes.mapEditor}?mapEditorId=${map?.editors?.[0]?.id}`)}
                                >
                                    <ExternalLink size={18} />
                                    {gW("view-map")}
                                </Button>
                            ) : (
                                /* الحالة البديلة: عند عدم وجود صلاحية تعديل أو بيئة نشطة */
                                <Button 
                                    className="w-full justify-center gap-2 bg-gray-100 text-gray-400 cursor-not-allowed"
                                    disabled
                                >
                                    <ExternalLink size={18} />
                                    {gW("no-active-environment")}
                                </Button>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </motion.div>
    );
};